<script>
export default {
  data() {
    return {
          dataList:[]
    };
  },
   props:{
         ExpertList:{
           type:Array
          
         
         },
         page:{
           
         },

   },
   watch:{
     ExpertList:{
       handler(newVal,oldVal){
         if(newVal!=oldVal){
           this.dataList=newVal
         }
         
       }, 
       deep:true,
       immediate:true
     }
   },
  methods: {
    /**
     * @description: 跳转医生主页
     * @param {res} 医生信息
     * @return {*}
     */    
    doctorDetail(res){
     const str= this.$parent.$parent.showShareCagechild?'cagechild':''
      this.$router.push({
        path:'/doctor',
        query:{
          id:res.authorId,
          share:str
        }
      })
      sessionStorage.removeItem("currentPlayStatus")
     
    },
    
  },

  render() {
    return (
     
        <div class="article">
          
            {this.dataList.map((res) => {
            
              return (
                <div class="article_list" onClick={()=>this.doctorDetail(res)}>
                <div class="article_box">
                  <div class="audio">
                    <img
                      class="bg_img"
                      v-lazy={res.urlOne}
                      
                    />
                  </div>
                  <div class="article_box_details article_box_border">
                    <div class="title">{res.authorName}<span class="tag">{res.authorTitle}</span> </div>
                    <div class="time">
                      <p>
                        <span class='intro'>
                         {res.authorDesc}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
                </div>
              );
            })}
          
        </div>
      
    )
  }
  
};
</script>
<style lang="less" scoped>
@import "../../../../assets/less/parenAudio.less";
.article {
 /deep/ .title {
    margin-bottom: 15px!important;
    .tag {
      color: #D4A437;
      font-size: 12px;
      margin-left: 10px;
    }
  }
  .time {
  .intro { 
    width: 238px;
    overflow:hidden;
    display:-webkit-box!important; //将对象作为弹性伸缩盒子模型显示;
    text-overflow:ellipsis;//溢出部分用省略号代替
    -webkit-line-clamp:2; //设置文本显示两行
    -webkit-box-orient:vertical;  //从上到下排列子元素;
    white-space:normal;

     }
  }
  .article_list .article_box .article_box_border {
    padding-bottom: 5px;
  border-bottom: solid 1px #F2F2F2;
 
}
  
}
</style>